import { compose } from 'recompose';
import { graphql } from '@apollo/react-hoc';
import gql from 'graphql-tag';
import get from 'lodash/get';

import { UniqueWithinTypeEncode } from '../../../apollo';

const followArtistMutation = gql`
  mutation follow($artistId: ID!) {
    setFollowArtist(artistId: $artistId, follow: true) {
      isFollowed
    }
  }
`;

const ARTIST_IS_FOLLOWED_FRAGMENT = gql`
  fragment ArtistIsFollowedFragment on rbm_Artist {
    isFollowedArtist
  }
`;

const updateArtistInCache = artistId => (cache, { data }) => {
  const id = `rbm_Artist:${UniqueWithinTypeEncode('Artist', artistId)}`;

  const isFollowedArtist = get(data, 'setFollowArtist.isFollowed');

  cache.writeFragment({
    id,
    fragment: ARTIST_IS_FOLLOWED_FRAGMENT,
    data: {
      __typename: 'rbm_Artist',
      isFollowedArtist
    }
  });
};

const follow = graphql(followArtistMutation, {
  name: 'followArtist',
  props: ({ followArtist }) => ({
    followArtist: ({ artistId }) =>
      followArtist({
        variables: { artistId },
        optimisticResponse: {
          __typename: 'Mutation',
          setFollowArtist: {
            __typename: 'rbm_FollowedArtist',
            isFollowed: true
          }
        },
        update: updateArtistInCache(artistId)
      })
  })
});

const unfollowArtistMutation = gql`
  mutation unfollow($artistId: ID!) {
    setFollowArtist(artistId: $artistId, follow: false) {
      isFollowed
    }
  }
`;

const unfollow = graphql(unfollowArtistMutation, {
  name: 'unfollowArtist',
  props: ({ unfollowArtist }) => ({
    unfollowArtist: ({ artistId }) =>
      unfollowArtist({
        variables: { artistId },
        optimisticResponse: {
          __typename: 'Mutation',
          setFollowArtist: {
            __typename: 'rbm_FollowedArtist',
            isFollowed: false
          }
        },
        update: updateArtistInCache(artistId)
      })
  })
});

const withToggleFollowArtist = Component =>
  compose(
    follow,
    unfollow
  )(Component);

withToggleFollowArtist.displayName = 'withToggleFollowArtist';

export default withToggleFollowArtist;
